import { NotificationManager } from "react-notifications";

class Notifications {
  static info(text: string) {
    NotificationManager.info(text);
  }

  static success(text: string) {
    NotificationManager.success(text);
  }

  /** A success toast that undoes when clicked, for 8 seconds. */
  static undoable(text: string, undo: () => void) {
    NotificationManager.success(`${text} Click to undo.`, "", 8000, undo);
  }

  static error(text: string) {
    NotificationManager.info(text);
  }
}

export default Notifications;
